import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { getCostBasisMap } from '../../../redux/modules/costBasis/costBasis.selectors';
import { ApplicationState } from '../../../redux/modules/types';
import { COST_BASIS_DISPLAY_MAP } from '../../../settings/settings';
import { agreementKey } from '../../../utils/funds/funds-utility';
import { Fund } from '../../Exchange/types';
import styles from './CostBasisSnapshot.module.scss';
import { CostBasisSnapshotState } from './types';
import { isAutomaticSell } from '../../../utils/transactions-util';
import { isRAS } from '../../../utils/advice/advice-utility';

export interface CostBasisSnapshotProps {
  isSalesforceRep: boolean;
  customerWebViewEnabled: boolean;
  changeAction?(): void;
  costBasisMap: Record<string, CostBasisSnapshotState>;
  fund: Partial<Fund>;
  labelComponent?: JSX.Element;
}

export const CostBasisSnapshot: React.FC<CostBasisSnapshotProps> = ({
  isSalesforceRep,
  customerWebViewEnabled,
  changeAction,
  costBasisMap,
  fund: { agreementID, agreementNumber, productType },
  labelComponent,
}) => {
  const currentCostBasis =
    costBasisMap[agreementKey(agreementID, agreementNumber)];
  const costBasisMethod =
    COST_BASIS_DISPLAY_MAP[currentCostBasis?.costBasisMethodType] || 'N/A';

  return (
    <div
      className={classNames(
        isAutomaticSell() ? styles['auto-cost-basis-snapshot'] : '',
        styles['cost-basis-snapshot'],
        'e2e-cost-basis-snapshot'
      )}
    >
      <a className={styles['cb-tooltip-trigger']}>
        {labelComponent || 'Cost Basis Method:'}
      </a>
      <span className={styles['cost-basis-display-name']}>
        {costBasisMethod}
      </span>
      {changeAction &&
        !(!customerWebViewEnabled && isSalesforceRep) &&
        !isRAS(productType) && (
          <a
            className={styles['cost-basis-change-link']}
            onClick={changeAction}
          >
            Change
          </a>
        )}
    </div>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    costBasisMap: getCostBasisMap(state),
  };
};

export default connect(mapStateToProps)(CostBasisSnapshot);
